import Skeleton from 'react-loading-skeleton';

const OfferintsFilterThemasSkeleton = () => {
  return (
    <>
      <li>
        <div className="u-margin-bottom-xs">
          <Skeleton />
        </div>
      </li>
      <li>
        <div className="u-margin-bottom-xs">
          <Skeleton />
        </div>
      </li>
      <li>
        <div className="u-margin-bottom-xs">
          <Skeleton />
        </div>
      </li>
      <li>
        <div className="u-margin-bottom-xs">
          <Skeleton />
        </div>
      </li>
      <li>
        <div className="u-margin-bottom-xs">
          <Skeleton />
        </div>
      </li>
      <li>
        <div className="u-margin-bottom-xs">
          <Skeleton />
        </div>
      </li>
      <li>
        <div className="u-margin-bottom-xs">
          <Skeleton />
        </div>
      </li>
    </>
  );
};

export default OfferintsFilterThemasSkeleton;
